module.exports = __webpack_public_path__ + "img/bujin_tiles_big.7cf024fe.jpg";